/* eslint-disable */
const Crossword = {
  data: function () {
    return {
      letter: 0,
      dica_selecionada: '',
      initial_cell: '',
      tips_ordered: '',
      finished: false,
      verificado: false,
      verified_words: [],
      letter_complete: [],
      posicao: {
        row: 0,
        column: 0
      }
    }
  },
  props: {
    matrix: Array,
    chaves: Object,
    verificar: Function,
    heightCell: Number,
    type: Number,
    gabarito: Array,
    pts: Number,
    time: Number,
    finish: Boolean,
    
  },
  created: async function() {
    if(this.finish) this.finished = true
    if(!this.finished) {
      window.addEventListener('keyup', (e) => this.readLetters(e));
    }
  },
  mounted: async function () {
    this.tips_ordered = await this.orderTips(this.chaves);
    const c = await this.searchFirstWord('horizontal')
    this.initial_cell = c
    await this.paintWord(c)
    await this.setCell(c.palavras.y, c.palavras.x);
    this.dica_selecionada = c
    await this.matrix.map(x => {
      x.map(y => {
        if(y.letra == null) y.letra = ""
      })
    })
    if(this.finished){
      await this.pauseCrossWord()
      await this.verifyCrossWord()
    }

  },
  destroyed() {
    this.$parent = null
    window.removeEventListener('keyup', (e) => this.readLetters(e));
  },
  methods: {
    readLetters: function(e){
      if( this.$parent != null && (!this.finished && !this.$parent.pause)){
      let self = this;
      if (e.keyCode == 8) {
        self.deleteLetter(self.posicao);
        let l = self.posicao
        if (self.verifyIfJumpPrevCell(l, self.dica_selecionada.palavras.direcao)) {
          self.jumpPrevCell(l, self.dica_selecionada.palavras.direcao);
        }
      }else if(e.keyCode == 39){
        self.removeStyleofCell()
        try{
          self.jumpNextCell(self.posicao, 0);
          let tip = this.getTipByCell(this.matrix[this.posicao.row][this.posicao.column])
          this.paintWord(tip)
          this.dica_selecionada = tip
        }catch{
          try{
            this.dica_selecionada = this.chaves.horizontal[this.matrix[this.posicao.row][this.posicao.column].palavra_horizontal][0]
            this.paintWord(this.dica_selecionada)
          }catch{
            this.changeTip('next')
          }
        }
      }else if(e.keyCode == 37){
        self.removeStyleofCell()
        try{
          self.jumpPrevCell(self.posicao, 0);
          let tip = this.getTipByCell(this.matrix[this.posicao.row][this.posicao.column - 1])
          this.paintWord(tip)
          this.dica_selecionada = tip
        }catch{
          try{
            this.dica_selecionada = this.chaves.horizontal[this.matrix[this.posicao.row][this.posicao.column].palavra_horizontal][0]
            this.paintWord(this.dica_selecionada)
          }catch{
            this.changeTip('back')
          }
        }
      }else if(e.keyCode == 40){
        self.removeStyleofCell()
        try{
          self.jumpNextCell(self.posicao, 1);
          let tip = this.getTipByCell(this.matrix[this.posicao.row + 1][this.posicao.column])
          this.paintWord(tip)
          this.dica_selecionada = tip
        }catch{
          try{
            this.dica_selecionada = this.chaves.vertical[this.matrix[this.posicao.row][this.posicao.column].palavra_vertical][0]
            this.paintWord(this.dica_selecionada)
          }catch{
            this.changeTip('next')
          }
        }
      }else if(e.keyCode == 38){
        self.removeStyleofCell()
        try{
          self.jumpPrevCell(self.posicao, 1);
          let tip = this.getTipByCell(this.matrix[this.posicao.row - 1][this.posicao.column])
          this.paintWord(tip)
          this.dica_selecionada = tip
        }catch{
          try{
            this.dica_selecionada = this.chaves.vertical[this.matrix[this.posicao.row][this.posicao.column].palavra_vertical][0]
            this.paintWord(this.dica_selecionada)
          }catch{
            this.changeTip('back')
          }
        }
      }
      else {
        try{
          if (self.insertLetterInCell(self.posicao, e.key)) {
            let l = self.posicao
            if (self.verifyIfJumpNextCell(l, self.dica_selecionada.palavras.direcao)) {
              self.jumpNextCell(l, self.dica_selecionada.palavras.direcao);
            }
          }
        }catch{
          console.log('tag', 'err')
        }
        
      }
      }
      
    },
    insertLetterInCell: function (location, letter) {
      if(!this.$parent.pause){
        let isValid = ((/^[a-zA-Z ]+$/).test(letter) && letter.length == 1)
        if (isValid){
          this.matrix[location.row][location.column].letra = letter
          let letter_exist = this.verified_words.filter(item => item.column == location.column && item.row == location.row).length > 0 ? true : false
          if(!letter_exist){
            this.letter_complete.push(location);
          }
          if( (letter == (this.gabarito[location.row][location.column].letra).toLowerCase()) && !letter_exist){
            if(!this.verificado){
              this.$parent.pts = parseInt(this.$parent.pts) + 1;
            }
            this.verified_words.push(location);
            
          }else if((letter != (this.gabarito[location.row][location.column].letra).toLowerCase()) && letter_exist){
            this.$parent.pts = parseInt(this.$parent.pts) - 1;
            this.verified_words = this.verified_words.filter(item => item != location)
          }
        } 
        return isValid
      }
     
    },
    deleteLetter: function (location) {
      this.matrix[location.row][location.column].letra = ""
      let correct_letter_exist = this.verified_words.filter(item => item.column == location.column && item.row == location.row).length > 0 ? true : false
      let letter_exist = this.letter_complete.filter(item => item.column == location.column && item.row == location.row).length > 0 ? true : false

      if(letter_exist){
        let index = this.letter_complete.findIndex(item => item.column == location.column && item.row == location.row)
        this.letter_complete.splice(index, 1);
      }
      
      if(correct_letter_exist){
        this.$parent.pts = parseInt(this.$parent.pts) - 1;
        this.verified_words = this.verified_words.filter(item => item != location)
      }
    },
    verifyIfJumpNextCell(location, direction) {
      let self = this;
      try {
        if (direction == 0) {
          if (this.matrix[location.row][parseInt(location.column) + 1] &&
            this.matrix[location.row][parseInt(location.column) + 1][`palavra_horizontal`] > 0) {
            if(this.matrix[location.row][parseInt(location.column) + 1].letra != ""){
              let el = document.getElementById(`row${location.row}column${location.column}`).classList
              if (el.contains('selected_cell')) el.remove('selected_cell')
              let {x,y} = this.searchNextLetterEmpty()
              this.setCell(x,y);
            }else{
              return true
            }
          } else {
            this.changeTip('next')
          }
        } else {
          if (this.matrix[parseInt(location.row) + 1][location.column] &&
            this.matrix[parseInt(location.row) + 1][location.column][`palavra_vertical`] > 0) {

              if(this.matrix[parseInt(location.row) + 1][location.column].letra != ""){
                let el = document.getElementById(`row${location.row}column${location.column}`).classList
              if (el.contains('selected_cell')) el.remove('selected_cell')
              let {x,y} = this.searchNextLetterEmpty()
              this.setCell(x,y);
              }else{
                return true
              }
           
          } else {
            this.changeTip('next')
          }
        }
      } catch (e) {
        console.log('tag', e)
        this.changeTip('next')
      }

    },
    verifyIfJumpPrevCell: function (location, direction) {
      if (direction == 0) {
        if (this.matrix[location.row][parseInt(location.column) - 1] &&
          this.matrix[location.row][parseInt(location.column) - 1][`palavra_horizontal`] > 0) {
          return true
        } else {
          let self = this;
          this.changeTip('back', {
            delete: () => {
              const arr = Object.entries(self.chaves['horizontal'])
              const index = arr.findIndex(item => item[1][0].indice == self.dica_selecionada.indice)
              document.getElementById(`row${self.dica_selecionada.palavras.y}column${self.dica_selecionada.palavras.x}`).classList.remove('selected_cell')
              if (index >= 0) {
                self.setCell(self.dica_selecionada.palavras.y, parseInt(self.dica_selecionada.palavras.x + self.dica_selecionada.tamanho - 1))
              } else {
                self.setCell(self.dica_selecionada.palavras.y + self.dica_selecionada.tamanho - 1, parseInt(self.dica_selecionada.palavras.x))
              }
            }
          }).delete()
        }
      } else {
        let self = this;
        try {
          if (this.matrix[parseInt(location.row) - 1][location.column] && this.matrix[parseInt(location.row) - 1][location.column][`palavra_vertical`] > 0) {
            return true
          } else {
            this.changeTip('back', {
              delete: () => {
                const arr = Object.entries(self.chaves['vertical'])
                
                const index = arr.findIndex(item => item[1][0].indice == self.dica_selecionada.indice)
                document.getElementById(`row${self.dica_selecionada.palavras.y}column${self.dica_selecionada.palavras.x}`).classList.remove('selected_cell')
                if (index >= 0) {
                  self.setCell(parseInt(self.dica_selecionada.palavras.y) + parseInt(self.dica_selecionada.tamanho) - 1, self.dica_selecionada.palavras.x)
                } else {
                  self.setCell(self.dica_selecionada.palavras.y, parseInt(self.dica_selecionada.palavras.x + self.dica_selecionada.tamanho - 1))
                }
              }
            }).delete()
          }
        } catch (e) {
          console.log(e)
          this.changeTip('back', {
            delete: () => {
              const arr = Object.entries(self.chaves['vertical'])
              const index = arr.findIndex(item => item[1][0].indice == self.dica_selecionada.indice)
              document.getElementById(`row${self.dica_selecionada.palavras.y}column${self.dica_selecionada.palavras.x}`).classList.remove('selected_cell')
              if (index >= 0) {
                self.setCell(parseInt(self.dica_selecionada.palavras.y) + parseInt(self.dica_selecionada.tamanho) - 1, self.dica_selecionada.palavras.x)
              } else {
                self.setCell(self.dica_selecionada.palavras.y, parseInt(self.dica_selecionada.palavras.x + self.dica_selecionada.tamanho - 1))
              }
            }
          }).delete()
        }
      }
    },
    jumpNextCell: function (location, direction) {
      const el = document.getElementById(`row${location.row}column${location.column}`).classList
      if (el.contains('selected_cell')) el.remove('selected_cell')
      if (direction == 0) {
        this.setCell(location.row, parseInt(location.column) + 1)
      } else {
        this.setCell(parseInt(location.row) + 1, location.column)
      }
    },
    jumpPrevCell: function (location, direction) {
      const el = document.getElementById(`row${location.row}column${location.column}`).classList
      if (el.contains('selected_cell')) el.remove('selected_cell')
      if (direction == 0) {
        this.setCell(location.row, parseInt(location.column) - 1)
      } else {
        this.setCell(parseInt(location.row) - 1, location.column)
      }
    },
    searchFirstWord: function (direction) {
      const copy = [...this.matrix]
      const d = direction == 'vertical' ? 1 : 0
      let cell = copy.map(el => el.filter(item => item[`palavra_${direction}`] > 0))
      cell = cell.filter(el => el.length > 0)[0][0]
      return this.tips_ordered.filter(item => item.indice == cell.numero && item.palavras.direcao == d)[0]
    },
    orderTips: function (tips) {
      let copy = { ...tips };
      console.log(tips)
      let h = Object.entries(copy['horizontal']).map(el => el[1][0]);
      let v = Object.entries(copy['vertical']).map(el => el[1][0]);
      return h.concat(v).sort((a, b) => a.indice - b.indice);
    },
    paintWord: function (tip) {
      let x, y, size, direction;
      x = tip.palavras.x
      y = tip.palavras.y
      size = tip.tamanho;
      direction = tip.palavras.direcao == 0 ? 'h' : 'v'
      if (direction == 'h') {
        for (let i = x; i < x + size; i++) {
          document.getElementById(`row${y}column${i}`).classList.add('select')
        }
      } else {
        for (let i = y; i < y + size; i++) {
          document.getElementById(`row${i}column${x}`).classList.add('select')
        }
      }
    },
    getTipByCell: function (cell) {
      return this.tips_ordered.filter(item => item.indice == cell.numero)
    },
    setCell: function (y, x) {
     
      
      this.posicao = {
        row: y,
        column: x
      }
      if (document.getElementById(`row${y}column${x}`)) document.getElementById(`row${y}column${x}`).classList.add('selected_cell')
       this.$parent.pause = false
    },
    changeTip: function (felt, ...args) {
      //felt - reproduz o sentido de ir ou volta nas dicas 
      let d = this.dica_selecionada.palavras.direcao == 0 ? 'horizontal' : 'vertical'
      let arrayTips = Object.entries(this.chaves[d])
      let index = arrayTips.findIndex(item => item[1][0].id == this.dica_selecionada.id)
      let sizeArrayTips = Object.entries(this.chaves[d]).length - 1;

      if (this.type == 3) {
        this.changeTipInOrder(felt)
      } else {
        if (felt == 'next') {
          if (index >= sizeArrayTips) {
            if (d == 'horizontal') {
              this.dica_selecionada = Object.entries(this.chaves['vertical'])[0][1][0]
            } else {
              this.dica_selecionada = Object.entries(this.chaves['horizontal'])[0][1][0]
            }
          } else {
            this.dica_selecionada = arrayTips[index + 1][1][0]
          }
        } else {
          if (index - 1 >= 0) {
            this.dica_selecionada = arrayTips[index - 1][1][0]
          } else {
            if (d == 'horizontal') {
              this.dica_selecionada = Object.entries(this.chaves['vertical'])[sizeArrayTips][1][0]
            } else {
              this.dica_selecionada = Object.entries(this.chaves['horizontal'])[sizeArrayTips][1][0]
            }

          }
        }
      }
      if(felt == 'next'){
        let coord = this.verifyWordIsComplete(this.dica_selecionada)
      this.removeStyleofCell()
      this.paintWord(this.dica_selecionada)
      if (coord != true) {
        this.setCell(coord.x, coord.y)
      } else {
        if (this.verifyCrosswordIsComplete()) {
          this.removeStyleofCell()
          this.$store.commit("setStateModal", {
            visible: true,
            title: "Jogo Finalizado!",
            type: "success",
            message: `Deseja verificar as respostas?`,
            callbackOk: () => this.verifyCrossWord()
          });
        } else {
          this.changeTip('next');
        }
      }
      }else{
        this.removeStyleofCell()
        this.paintWord(this.dica_selecionada)
        if(this.dica_selecionada.direcao == 1){
          this.setCell(parseInt(this.dica_selecionada.palavras.y) + parseInt(this.dica_selecionada.tamanho) - 1, this.dica_selecionada.palavras.x)
        }else{
          this.setCell(this.dica_selecionada.palavras.y, parseInt(this.dica_selecionada.palavras.x + this.dica_selecionada.tamanho - 1))
        }

      }
      
      return args[0]
    },
    selectCellsOfWord: function (celula, e) {
      this.removeStyleofCell()
      if (e) this.setCell(e.target.id.split('c')[0].replace(/\D/g, ''), e.target.id.split('c')[1].replace(/\D/g, ''))
      const horizontal = celula.palavra_horizontal > 0 ? 1 : 0
      const vertical = celula.palavra_vertical > 0 ? 1 : 0
      const init_direction = this.initial_cell.palavras.direcao
      const init_id = this.initial_cell.palavras.id
      if (horizontal && vertical) {
        if (init_direction === 0 && init_id == celula.palavra_horizontal) {
          this.dica_selecionada = this.chaves.vertical[celula.palavra_vertical][0]
          this.paintWord(this.chaves.vertical[celula.palavra_vertical][0])
        } else if (init_direction === 0 && init_id != celula.palavra_horizontal) {
          this.dica_selecionada = this.chaves.horizontal[celula.palavra_horizontal][0]
          this.paintWord(this.chaves.horizontal[celula.palavra_horizontal][0])
        } else if (init_direction === 1 && init_id == celula.palavra_vertical) {
          this.dica_selecionada = this.chaves.horizontal[celula.palavra_horizontal][0]
          this.paintWord(this.chaves.horizontal[celula.palavra_horizontal][0])
        } else if (init_direction === 1 && init_id != celula.palavra_vertical) {
          this.dica_selecionada = this.chaves.vertical[celula.palavra_vertical][0]
          this.paintWord(this.chaves.vertical[celula.palavra_vertical][0])
        }
      } else if (!horizontal && vertical) {
        this.dica_selecionada = this.chaves.vertical[celula.palavra_vertical][0]
        this.paintWord(this.chaves.vertical[celula.palavra_vertical][0])
      } else if (horizontal && !vertical) {
        this.dica_selecionada = this.chaves.horizontal[celula.palavra_horizontal][0]
        this.paintWord(this.chaves.horizontal[celula.palavra_horizontal][0])
      }
      this.initial_cell = this.dica_selecionada

    },
    searchWordsInHorizontal: function () {
      const copy = [...this.matrix]
      let cell = copy.map(el => el.filter(item => item.letra === '' && !item.casa_morta && item.numero > 0))
      return this.getTipByCell(cell.filter(el => el.length > 0)[0][0])
    },
    removeStyleofCell: function () {
      for (let column = 0; column < this.matrix.length; column++) {
        for (let row = 0; row < this.matrix[0].length; row++) {
          const el = document.getElementById(`row${column}column${row}`).classList
          if (el.contains('death')) el.add('death')
          if (el.contains('celula')) el.add('celula')
          if (el.contains('select')) el.remove('select')
          if (el.contains('selected_cell')) el.remove('selected_cell')
          if (el.contains('correct')) el.remove('correct')
          if (el.contains('incorrect')) el.remove('incorrect')
        }
      }
    },
    changeTipInOrder: async function (type) {
      this.removeStyleofCell()
      let copy_tips = [...this.tips_ordered]
      let i = copy_tips.findIndex(item => item.indice == this.dica_selecionada.indice)
      if (type == 'next') {
        if (i + 1 >= copy_tips.length) {
          this.dica_selecionada = copy_tips[0]
        } else {
          this.dica_selecionada = copy_tips[i + 1]
        }
        await this.setCell(this.dica_selecionada.palavras.y, this.dica_selecionada.palavras.x)
      } else {
        if (i - 1 < 0) {
          this.dica_selecionada = copy_tips[copy_tips.length - 1]
        } else {
          this.dica_selecionada = copy_tips[i - 1]
        }
      }

      await this.paintWord(this.dica_selecionada)
    },
    getClassArrowPosition: function (obj, row, column) {
      if (obj.palavra_1 != -1 && obj.palavra_2 == -1) {

        if (obj.palavra_1.x > column) {
          if (obj.palavra_1.direcao == 0) {
            return 'fa-caret-right arrow_right '
          } else {
            return 'curved_arrow_left '
          }
        }
        else if (obj.palavra_1.y > row) {
          if (obj.palavra_1.direcao == 1) {
            return 'fa-caret-down arrow_down '
          } else {
            return 'curved_arrow_bottom '
          }
        }
        else if (obj.palavra_1.y < row) {
          if (obj.palavra_1.direcao == 0) {
            return 'arrow_left_cima '
          }
        }
        else if (obj.palavra_1.y < column) {
          if (obj.palavra_1.direcao == 1) {
            return 'arrow_bottom_lado '
          }
        }
      } else if (obj.palavra_1 == -1 && obj.palavra_2 != -1) {

        if (obj.palavra_2.x > column) {
          if (obj.palavra_2.direcao == 0) {
            return 'fa-caret-right arrow_right '
          } else {
            return 'curved_arrow_left '
          }
        }

        if (obj.palavra_2.y > row) {
          if (obj.palavra_2.direcao == 1) {
            return 'fa-caret-down arrow_down '
          } else {
            return 'curved_arrow_bottom '
          }
        }

        if (obj.palavra_2.y < row) {
          if (obj.palavra_2.direcao == 0) {
            return 'arrow_left_cima '
          }
        }

        else if (obj.palavra_2.y < column) {
          if (obj.palavra_2.direcao == 1) {
            return 'arrow_bottom_lado '
          }
        }

      } else if (obj.palavra_1 != -1 && obj.palavra_2 != -1) {
        let classe = ''

        if (obj.palavra_1.x > column) {
          if (obj.palavra_1.direcao == 0) {
            classe += 'fa-caret-right arrow_right '
          } else {
            classe += 'curved_arrow_left '
          }
        }

        if (obj.palavra_1.y < column && obj.palavra_1.x == row) {
          if (obj.palavra_1.direcao == 1) {
            classe += 'arrow_bottom_lado '
          }
        }

        if (obj.palavra_1.y > row) {
          if (obj.palavra_1.direcao == 1) {
            classe += 'fa-caret-down arrow_down '
          } else {
            classe += 'curved_arrow_bottom '
          }
        }

        if (obj.palavra_1.y < row) {
          if (obj.palavra_1.direcao == 0) {
            classe += 'arrow_left_cima '
          }
        }

        if (obj.palavra_2.x > column) {
          if (obj.palavra_2.direcao == 0) {
            classe += 'fa-caret-right arrow_right '
          } else {
            classe += 'curved_arrow_left '
          }
        }

        if (obj.palavra_2.y < column && obj.palavra_1.x == row) {
          if (obj.palavra_2.direcao == 1) {
            classe += 'arrow_bottom_lado '
          }
        }


        if (obj.palavra_2.y > row) {
          if (obj.palavra_2.direcao == 1) {
            classe += 'fa-caret-down arrow_down '
          } else {
            classe += 'curved_arrow_bottom '
          }
        }

        if (obj.palavra_2.y < row) {
          if (obj.palavra_2.direcao == 0) {
            classe += 'arrow_left_cima '
          }
        }

        return classe
      }
    },
    validatorArrow: function (state, prefix) {
      if (state) {
        return (state.split(' ').some(item => item == prefix))
      }
    },
    verifyWordIsComplete: function (tip) {
      let x, y, size, direction;
      x = tip.palavras.x
      y = tip.palavras.y
      size = tip.tamanho;
      direction = tip.palavras.direcao == 0 ? 'h' : 'v'
      if (direction == 'h') {
        for (let i = x; i < x + size; i++) {
          if (this.matrix[y][i].letra.length == 0) {
            return { x: y, y: i }
          }
        }
      } else {
        for (let i = y; i < y + size; i++) {
          document.getElementById(`row${i}column${x}`).classList.add('select')
          if (this.matrix[i][x].letra.length == 0) {
            return { x: i, y: x }
          }
        }
      }
      return true
    },
    verifyCrosswordIsComplete: function () {
      return !(this.matrix.map(el => el.filter(item => (item.palavra_vertical > 0 || item.palavra_horizontal > 0) && item.letra == ''))).some(item => item.length > 0)
    },
    revealLetter: function () {
      let { column, row } = this.posicao
      this.matrix[row][column].letra = this.gabarito[row][column].letra
    },
    revealCrossWord: function () {
      let copy = [...this.matrix]
      for (let c = 0; c < copy.length; c++) {
        for (let r = 0; r < copy[c].length; r++) {
          this.matrix[c][r].letra = this.gabarito[c][r].letra
        }
      }
    },
    clearCrossWord: function () {
      let copy = [...this.matrix]
      for (let c = 0; c < copy.length; c++) {
        for (let r = 0; r < copy[c].length; r++) {
          this.matrix[c][r].letra = ''
        }
      }
      this.removeStyleofCell()
      this.$parent.pts = 0;
      this.verified_words = []
    },
    searchNextLetterEmpty(){
      let tip = { ...this.dica_selecionada }
      let x, y, size, direction;
      x = tip.palavras.x
      y = tip.palavras.y
      size = tip.tamanho;
      direction = tip.palavras.direcao == 0 ? 'h' : 'v'
      if(direction == 'h'){
        for (let i = x; i < x + size; i++) {
          if(this.matrix[y][i].letra == ''){
            return {x: y, y: i}
          }
        }
      }else{
        for (let i = y; i < y + size; i++) {
          if(this.matrix[i][x].letra == ''){
            return {x: i, y: x};
          }
        }
      }
    },
    clearWord: function () {
      let tip = { ...this.dica_selecionada }
      let x, y, size, direction;
      x = tip.palavras.x
      y = tip.palavras.y
      size = tip.tamanho;
      direction = tip.palavras.direcao == 0 ? 'h' : 'v'
      if (direction == 'h') {
        for (let i = x; i < x + size; i++) {
          this.matrix[y][i].letra = ''
        }
      } else {
        for (let i = y; i < y + size; i++) {
          this.matrix[i][x].letra = ''
        }
      }
    },
    revealWord: function () {
      let tip = { ...this.dica_selecionada }
      let x, y, size, direction;
      x = tip.palavras.x
      y = tip.palavras.y
      size = tip.tamanho;
      direction = tip.palavras.direcao == 0 ? 'h' : 'v'
      if (direction == 'h') {
        for (let i = x; i < x + size; i++) {
          this.matrix[y][i].letra = this.gabarito[y][i].letra
        }
      } else {
        for (let i = y; i < y + size; i++) {
          this.matrix[i][x].letra = this.gabarito[i][x].letra
        }
      }
    },
    verifyCrossWord: async function () {
      if(!this.verificado){
        this.verificado = true;
      }
      await this.removeStyleofCell()
      let copy = [...this.matrix]
      for (let c = 0; c < copy.length; c++) {
        for (let r = 0; r < copy[c].length; r++) {
          if (!this.matrix[c][r].casa_morta && this.matrix[c][r].letra.length > 0) {
            if (this.matrix[c][r].letra == this.gabarito[c][r].letra) {
              await document.getElementById(`row${c}column${r}`).classList.add('correct')
            } else {
              await document.getElementById(`row${c}column${r}`).classList.add('incorrect')
            }
          }
        }
      }
    },
    finishCrossWord: async function (id, time, pts) {
      if(localStorage.getItem('t')){
        let matrix = [...this.matrix];
        await this.$axios
          .post(`/passatempos/${id}/verificar`, {
            matrix: matrix,
            tempo: time,
            pontuacao: pts,
          })
          .then((res) => res.data)
          .then(async () => {
            await this.verifyCrossWord()
  
            await this.$store.commit("setStateModal", {
              visible: true,
              title: "Parabens",
              type: "success",
              message: `Você marcou ${pts} pontos no passatempo!`,
            });
            
          })
          .catch((err) => {
            this.$store.commit("setStateModal", {
              visible: true,
              title: "Calma ai!",
              type: "error",
              message: err.response.data.message,
            });
          });
      }else{
        this.$store.commit("setStateModal", {
          visible: true,
          title: "Calma ai!",
          type: "error",
          message: "Faça login para continuar!",
        });
        this.$router.push({path: '/login'})
      }
     
    },
    pauseCrossWord: function(){
      if(this.$parent.pause){
        this.$parent.pause = false
      }else{
        this.$parent.pause = true;
      }
    },
    saveCrossWord: function(id,time){
      let dados = {
        matrix: [...this.matrix],
        time: time,
        id: id,
        chaves: this.chaves
      }
      if (localStorage.getItem("t")) {
        this.$axios
          .post(`passatempos/${dados.id}/progresso`, dados)
          .then((res) => res.data)
          .then((res) => {
             this.$store.commit("setStateModal", {
              visible: true,
              title: "Sucesso",
              type: "success",
              message: "Jogo salvo com sucesso!",
            });
          })
          .catch((err) => {
             this.$store.commit("setStateModal", {
              visible: true,
              title: "Erro",
              type: "error",
              message: err.response.data.message,
            });
          });
      }
    },
    
    initCrossWord: function(){
      this.matrix.map(column => {
        column.map(row => {
          row.letra = ""
        })
      })
      this.clearCrossWord()
      this.$parent.timer = 0;
      this.finished = false
      window.addEventListener('keyup', (e) => this.readLetters(e));
    },

  }
}

export default Crossword;
